import Img from '@root/website-tooling/gatsby-image';
import PropTypes from '@root/vendor/prop-types';
import React, { useLayoutEffect, useState } from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';

export default function AlternateSizeGatsbyImage({
  desktop, mobile, imageAltText, styles, loading,
}) {
  const [sources, setSources] = useState();

  useLayoutEffect(() => {
    if (!desktop && !mobile) {
      setSources(null);
    } else {
      setSources([
        desktop && {
          ...desktop,
          media: Responsive.QUERIES.md,
        },
        mobile && {
          ...mobile,
          media: Responsive.QUERIES.lessThanMd,
        },
      ].filter((source) => source));
    }
  }, [desktop, mobile]);

  if (!sources) {
    return null;
  }

  return (
    <Img
      alt={imageAltText}
      css={styles}
      fluid={sources}
      loading={loading}
    />
  );
}

AlternateSizeGatsbyImage.propTypes = {
  desktop: PropTypes.object,
  imageAltText: PropTypes.string.isRequired,
  loading: PropTypes.oneOf(['eager', 'lazy', 'auto']),
  mobile: PropTypes.object,
  styles: PropTypes.object,
};
